module.exports = __webpack_public_path__ + "img/zilan.1f902b00.png";